import { ClockIcon, TagIcon, ViewGridIcon } from "@heroicons/react/outline";
import { PencilIcon } from "@heroicons/react/solid";
import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import Button from "components/button";
import { DescriptionItem } from "components/descriptionItem";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLodModal } from "components/historyLogModal";
import { IBlogSubCategoryItem } from "interfaces";
import { useState } from "react";
import { Link } from "react-router-dom";
import { isHaveActionPermission } from "utills/helpers";

export const BlogSubCategoryDetail: React.FC = () => {
  const [openLogModal, setOpenLogModal] = useState(false);

  const parse = useParse();
  const { params } = parse();
  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IBlogSubCategoryItem>({
    resource: "mkt/sub-categories",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const blogSubCategoryDetail = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="w-full flex flex-col items-center gap-y-3 sm:gap-y-4">
      <Breadcrumbs
        customPageLabel="Blogs - Sub categories Detail"
        additionalLabel={
          <div className="flex gap-x-2.5">
            <Button
              className="bg-white border-brand-500 border-[1px] border-solid text-brand-500 hover:bg-white active:bg-slate-200"
              onClick={() => setOpenLogModal(true)}
            >
              <span className="sr-only">History Log</span>
              <ClockIcon className="w-4 h-4 text-brand-500" />{" "}
              <span className="hidden sm:block sm:ml-2">Log</span>
            </Button>
            {isHaveActionPermission("blog_sub_categories", "mkt", "edit") ? (
              <Link to={`/mkt/sub-category/${blogSubCategoryDetail?.id}/edit`}>
                <Button>
                  <span className="sr-only">Edit</span>
                  <PencilIcon className="w-4 h-4 text-white" />{" "}
                  <span className="hidden sm:block sm:ml-2">Edit</span>
                </Button>
              </Link>
            ) : (
              <></>
            )}
          </div>
        }
      />
      <div className="box-container p-0">
        <div className="divide-y divide-gray-100">
          <DescriptionItem
            icon={TagIcon}
            label="Status"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {blogSubCategoryDetail?.is_active ? "Active" : "Inactive"}
              </p>
            }
          />
          <DescriptionItem
            icon={ViewGridIcon}
            label="Sub-category vie"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {blogSubCategoryDetail?.name_vi}
              </p>
            }
          />
          <DescriptionItem
            icon={ViewGridIcon}
            label="Sub-category eng"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {blogSubCategoryDetail?.name_en}
              </p>
            }
          />
          <DescriptionItem
            icon={ViewGridIcon}
            label="Category eng"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4 capitalize">
                {blogSubCategoryDetail?.category}
              </p>
            }
          />
        </div>
      </div>
      <HistoryLodModal
        resource={`mkt/sub-categories/${params?.id}/history`}
        open={openLogModal}
        onClose={() => setOpenLogModal(false)}
        key={"sub-category-log"}
      />
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}